import { render, staticRenderFns } from "./WorkFloTaskCard.vue?vue&type=template&id=01da2dce&"
import script from "./WorkFloTaskCard.vue?vue&type=script&lang=js&"
export * from "./WorkFloTaskCard.vue?vue&type=script&lang=js&"
import style0 from "./WorkFloTaskCard.vue?vue&type=style&index=0&id=01da2dce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports